import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Login from './components/Login';
import Register from './components/Register';
import Calendar from './components/Calendar';
import CalendarPage from './pages/CalendarPage';
import Scheduling from './components/Scheduling';
import Subscription from './components/Subscription';
import Sponsors from './components/Sponsors';
import ServicesPage from './pages/ServicesPage';
import WeddingRulesPage from './pages/WeddingRulesPage';
import ReunionRulesPage from './pages/ReunionRulesPage';
import PartyRulesPage from './pages/PartyRulesPage';
import SportingEventsRulesPage from './pages/SportingEventsRulesPage';
import SportPracticesRulesPage from './pages/SportPracticesRulesPage';
import FitnessAreaRulesPage from './pages/FitnessAreaRulesPage';
import WalkingTrackRulesPage from './pages/WalkingTrackRulesPage';
// import GamePage from './pages/GamePage'; // temporarily disabled — re-enable for a future rollout
import Team200Page from './pages/Team200Page';
import ContactUsButton from './components/ContactUsButton';
import { Analytics } from '@vercel/analytics/react';
import './App.css';

const LoginPage: React.FC = () => {
  const [isLoginMode, setIsLoginMode] = useState(true);
  const { user } = useAuth();
  const navigate = useNavigate();

  // If already logged in, redirect to home
  useEffect(() => {
    if (user) {
      navigate('/', { replace: true });
    }
  }, [user, navigate]);

  if (user) {
    return null;
  }

  return (
    <div className="login-page">
      {isLoginMode ? (
        <Login onToggleMode={() => setIsLoginMode(false)} />
      ) : (
        <Register onToggleMode={() => setIsLoginMode(true)} />
      )}
    </div>
  );
};

const AppContent: React.FC = () => {
  return (
    <div className="app">
      <Navbar />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Calendar />} />
          <Route path="/calendar" element={<CalendarPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/services/weddings" element={<WeddingRulesPage />} />
          <Route path="/services/reunions" element={<ReunionRulesPage />} />
          <Route path="/services/parties" element={<PartyRulesPage />} />
          <Route path="/services/sporting-events" element={<SportingEventsRulesPage />} />
          <Route path="/services/sport-practices" element={<SportPracticesRulesPage />} />
          <Route path="/services/fitness-area" element={<FitnessAreaRulesPage />} />
          <Route path="/services/walking-track" element={<WalkingTrackRulesPage />} />
          {/* <Route path="/game" element={<GamePage />} /> */}
          <Route path="/TEAM200" element={<Team200Page />} />
          <Route path="/team200" element={<Team200Page />} />
          <Route path="/login" element={<LoginPage />} />
          <Route 
            path="/schedule" 
            element={<Scheduling />} 
          />
          <Route 
            path="/subscription" 
            element={<Subscription />} 
          />
          <Route 
            path="/sponsors" 
            element={<Sponsors />} 
          />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </main>
      <div
        className="sticky-cta"
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
        }}
      >
        <ContactUsButton
          buttonText={<><span className="cta-text">Contact Us</span><span className="cta-icon">?</span></>}
          className="contact-button contact-button-alt contact-button-icon"
          defaultInquiry="information"
        />
      </div>
      <Footer />
      <Analytics />
    </div>
  );
};

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
};

export default App;